<template>
  <section id="project-analysis-text-main-sentiment">
    <div class="sentiment__header">
      <ul class="sentiment__header-labels main__search-labels">
        <transition name="fade">
          <li v-show="isSearchMode">
            <span
              class="main__highlight search"
              style="background-color: lightgreen"
              id="search-keyword"
            >
              <VisibleText>Search</VisibleText>
            </span>
          </li>
        </transition>
        <transition name="fade">
          <li v-show="highlightFilters.includes('pos-keyword')">
            <span class="main__highlight positive-sentiment" id="pos-keyword">
              <VisibleText>Positive phrases</VisibleText>
            </span>
          </li>
        </transition>
        <transition name="fade">
          <li v-show="highlightFilters.includes('neg-keyword')">
            <span class="main__highlight negative-sentiment" id="neg-keyword">
              <VisibleText>Negative phrases</VisibleText>
            </span>
          </li>
        </transition>
      </ul>
      <div class="select-wrapper sentiment__sort-wrapper" style="margin-right: 1rem">
        <label for="sentiment-sort-by" class="sentiment__sort-label">
          <VisibleText>Sort by:</VisibleText>
        </label>
        <select
          id="sentiment-sort-by"
          class="select sentiment__sort-options"
          v-model.number="sortBy"
        >
          <option value="-1" :data-parent="$options.name">
            {{ translate('Negative sentiment', $options.name) }}
          </option>
          <option value="0" :data-parent="$options.name">
            {{ translate('Default', $options.name) }}
          </option>
          <option value="1" :data-parent="$options.name">
            {{ translate('Positive sentiment', $options.name) }}
          </option>
        </select>
      </div>
    </div>
    <ResponseList
      ref="MainSentimentResponseRef"
      class="sentiment__response-list"
      :textAnalysisObject="textAnalysisObject"
      :propReadOnly="propReadOnly"
      :client-question-id="convertId(textAnalysisObject.selectedTextQuestion._id)"
      :responses="sortedResponses"
      :hidden-comments="textAnalysisObject.hiddenComments"
      :get-highlight-items-method="getHighlightItems"
      :hasPreProcessedText="hasPreProcessedText"
      :sortedResponsesLength="sortedResponsesLength"
      :includeSmartCoverage="includeSmartCoverage"
      :sortedThemes="sortedThemes"
      @updateExistingThemeTitle="updateExistingThemeTitle"
      @showSentimentDetails="$emit('showSentimentDetails', $event)"
      @ban-response="banResponseItem($event)"
      @adjust-sentiment="adjustSentimentItem"
      @toggle-response-hide="toggleResponseItemHide"
      @runSortAndSelect="$emit('runSortAndSelect')"
      @updateTextObject="$emit('updateTextObject', $event)"
      @updateTheme="$emit('updateTheme', $event)"
      @refreshTheme="refreshTheme($event)"
      @removeTheme="$emit('removeTheme', $event)"
    />
  </section>
</template>

<script>
// Components
import ResponseList from './Components/ResponseList.vue';

// Mixins
import textAnalysisMixin from '../Mixins/textAnalysisMixin.js';

export default {
  name: 'ProjectTextAnalysisMainSentiment',
  mixins: [textAnalysisMixin],
  components: {
    ResponseList,
  },
  props: {
    datasetIDQuestions: {
      default: () => [],
      type: Array,
    },
    highlightFilters: {
      type: Array,
      default: () => [],
    },
    textAnalysisObject: {
      type: Object,
      required: false,
      default: () => {},
    },
    sortedResponses: {
      type: Array,
      required: false,
      default: () => [],
    },
    hasPreProcessedText: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    includeSmartCoverage: {
      type: String,
      default: () => 'exclude',
    },
    sortedResponsesLength: {
      type: Number,
      required: false,
      default: () => 0,
    },
    sortedThemes: {
      type: Array,
      default: () => [],
    },
    propReadOnly: {
      default: () => false,
      type: Boolean,
    },
  },
  computed: {
    sortBy: {
      get: function () {
        return this.textAnalysisObject.sentimentSortOrder;
      },
      set: function (val) {
        this.setSentimentSortOrder(val);
      },
    },
  },
  methods: {
    refreshThemesFromParent() {
      if (this.$refs.MainSentimentResponseRef) {
        this.$refs.MainSentimentResponseRef.refreshThemesFromParent();
      }
    },
    convertId(id) {
      if (id && id.$oid) {
        return id.$oid;
      } else {
        return id;
      }
    },
    updateTextObject(cleanedProject) {
      let object = {
        project: cleanedProject,
        scroll: 'main',
      };
      this.$emit('updateTextObject', object);
    },
    findResponseScore(response) {
      if (!response.scores) {
        return 0;
      }
      return response.scores.sentiment || 0;
    },
    getHighlightItems(response) {
      if (!this.textAnalysisObject.activeTab === 'Sentiment') {
        return {};
      }

      let neg_keyword = [];
      let pos_keyword = [];

      if (this.textAnalysisObject.selectedTextQuestion) {
        if (this.hasPreProcessedText && this.textAnalysisObject.includeSentiments == 'include') {
          if (response.response_sentiment_bert && response.response_sentiment_bert.sentences) {
            pos_keyword.push(
              ...response.response_sentiment_bert.sentences.filter(
                (el) => el.sentiment == 'positive',
              ),
            );
            neg_keyword.push(
              ...response.response_sentiment_bert.sentences.filter(
                (el) => el.sentiment == 'negative',
              ),
            );
          }
        }
      }

      let obj = {
        'pos-keyword': pos_keyword,
        'neg-keyword': neg_keyword,
      };
      for (let key of Object.keys(obj)) {
        if (!this.highlightFilters.includes(key)) delete obj[key];
      }
      if (
        this.textAnalysisObject &&
        this.textAnalysisObject.search &&
        this.textAnalysisObject.search.searchResults
      ) {
        obj['search-keyword'] = this.textAnalysisObject.search.searchResults;
      }

      return obj;
    },
    refreshTheme(theme_id) {
      this.$emit('refreshTheme', theme_id);
    },
  },
  watch: {
    search: function (val) {
      const searchString = val.searchString;
      // reset sort
      if (searchString && searchString.trim() != '') this.sortBy = 0;
    },
  },
};
</script>
